import Modal, { setAppElement } from "react-modal";
import React, {useEffect, useState} from "react";
import './Variz.css'
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import { toast } from "react-toastify";
import { useAuthState } from "../../Context/auth-context";



export default function ({modalIsOpen,Openchanger}){

    const [carts,setcarts] = useState([])
    const [amount,setamount] = useState('')
    const [balance,setBalance] = useState('')
    let {cartNumber} = useState('')
    const isSmall = useMediaQuery('(max-width: 1000px)')
    const {isEhraz} = useAuthState()
    const [checkGoogle,setCheckGoogle] = useState(false)
    const[google,setGoogle] = useState('')



    const customStylesDesktop = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                


    },

          content: {
           background: '#FFFFFF',
                  width: '60rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(95vh - 2rem)',
                  overflowY: 'auto',
                  position: 'relative',
                  borderRadius: '0.8rem',
                  background: '#FDFCFF',
                  boxShadow: '0px 4px 16px rgba(8, 44, 95, 0.16)',
                  borderRadius: '32px'




          },


};

    const customStylesMobile = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(131, 131, 131, 0.13)',
                  display: 'flex',
                  justifyContent: 'center',
                  backdrop: 'blur(1.5px)',
                  


    },

          content: {
           background: '#FFFFFF',
                  width: '34rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(92vh - 1rem)',
                  overflowY: 'auto',
                  position: 'relative',
                  borderRadius: '0.4rem',
                  inset:'0px',
                  margin : '2vh 2px 2px 2px',
                  boxShadow: '0px 2.61792px 7.85375px rgba(8, 44, 95, 0.2)',
                  borderRadius:'15px',
                  height:'658px',
                  margin: '40px 0px 0px 0px'




          },


};

    Modal.setAppElement('#root');




    let subtitle;
    function afterOpenModal() {
  }
   function closeModal() {
        Openchanger(false)

  }

  function Gotolist() {
         window.location.replace('/ListBardasht')
     }


  useEffect(async ()=>{


      await axios.get('https://api.sinatether.com/Auth/CartEhraz/',{
              withCredentials:true

         
        }).then((response)=>{
          if (response.status == 200)
          {

              setBalance(response.data['balance'])
              setcarts(response.data['carts'])

          }
      }).catch((error)=>{
          if(error){
            
          }
      })


      await axios.get('https://api.sinatether.com/Auth/check_google').then((res)=>{



      if (res.status == 200){

          setCheckGoogle(res.data['is_auth_google'])
      }

   



   })

  },[])




    function handelpayment(){
 


        let radios = document.querySelectorAll('input[name="choice"]')
        if (amount<5000)
        {
            toast.dismiss()
            toast.error('حداقل مقدار برداشت 5000 تومان می باشد')
            return
        }


        if (!amount ){
            toast.dismiss()
            toast.error('مبلغ برداشت خود را وارد نمایید ')
            return
        }

        



    


        for (const rb of radios){
            if (rb.checked){
                cartNumber = rb.value;
                break;
            }
        }

        if (!cartNumber){
            toast.dismiss()
            toast.error('لطفا یکی از کارتهای احراز شده خود را انتخاب نمایید    ')
            return
        }


        axios.post('https://api.sinatether.com/Auth/BardashtRequest/',
            {'amount': amount,'cartNumber':cartNumber,'oauth':checkGoogle?google : ''},{
                withCredentials:true

         
        }).then((res)=>{
            let status = res.data['status']
            if (status === 200) {
                toast.dismiss()
                toast.success(res.data['message'])
                setTimeout(() => {
                    window.location.replace('/')
                }, 1500)

            }
            else if(status === 201){
                toast.dismiss()
                toast.error(res.data['message'])

            }

        }).catch((er)=>{
            if(er){
                if(er.response.status ==401 ){
                    toast.dismiss()
                toast.error(' نشست شما منقضی شده است مجددا وارد سایت شوید  ')
                    
                }else{
                    toast.dismiss()

                    toast.error('درخواست شما با موفقیت ثبت نشد')

                }
            }

        })
    }


    let num;

    






    function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value)
        } else {
            return x1 + x2;
        }
    }



    function ex_normalNum(num) {
            num = num.replace(/,\s?/g, "");
            setamount(num);
        }


        function handleChooseBalanceClick(){

            setamount(balance)

            document.getElementById('amount').value = new Intl.NumberFormat("fa").format(balance)

        }












  return(

      <>
          {isSmall ?



              <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={customStylesMobile}
        contentLabel="Example Modal"
        backdrop= "static"

      >


          <div className={'container'} id={'mbody'}>
              <div className={'title'}>
                  <span className="close" onClick={closeModal}>&times;</span>
                  <h4>برداشت تومانی</h4>
                  <hr/>


              </div>

              <div className={'row'}>
                  <form className={'col-md-7'}>
                      <span className={'text-large '}>
                          حداکثر مبلغ قابل برداشت:

                          {new Intl.NumberFormat("fa").format(balance)}
                          تومان


                      </span>


                      <div className="all-balance-b">

                      <button type="button"
                                                                className={'btn btn-sor btnes244 '} onClick={handleChooseBalanceClick}>
                                                                کل موجودی
                                                            </button>


                      </div>
                      

                  

                      <input id={'amount'} type={'input'} className={'form-control bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} onKeyUp={separateNum} placeholder={'مبلغ مورد نظر را وارد کنید'}  />


                      <div className="text-large jfhshjhfgs1323">
                            کارت مدنظر خود را انتخاب کنید
                        </div>


                   
                      <div className="panel-body list-group">
                                {carts ? carts.map((cart)=>(
                                    <div className="form-check border-dark ">

                                    <input className="form-check-input " type="radio" name="choice"
                                       id="flexRadioDefault1" value={cart.cart_number}/>
                                    <label className="form-check-label " >
                                        <div className="fofjsfdjf12">
                                            <span className={'fofjsfdjf12'} >شماره کارت :</span>
                                            {cart.cart_number}
                                        </div>
                    

                                        <div className={'text-large fofjsfdjf12'}>
                                        <span className={'fofjsfdjf12'} >شماره شبا:</span>

                                            {cart.sheba_number}

                                        </div>

                                    </label>
                                    </div>
                                    )): <h5></h5>}


                        </div>


                        
                        {checkGoogle?

                                <div className={'w-100  text-white'}>
                                    <label className={'text-large'}>کد تایید دو مرحله ای</label>


                                    <div className={'text-center'}>


                                        <input
                                            className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6  '} id={'google_code'} value={google} onChange={e=>setGoogle(e.target.value)}
                                            />
                                    </div>


                                </div>

                                :

                                <></>
                                }






                      <div className={''}>
                      <a href={'/ehzcart'} id={'abtn'} >
                                      <div class="row">
                                          <div className="col-1">
                                              <svg id="Group_27532" data-name="Group 27532" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
  <path id="Path_1" data-name="Path 1" d="M8.3,4.889a.292.292,0,0,0-.583,0V7.709H4.893a.292.292,0,1,0,0,.583H7.713v2.819a.292.292,0,1,0,.583,0V8.292h2.819a.292.292,0,0,0,0-.583H8.3Z" stroke="#000" stroke-width="1"/>
  <rect id="Rectangle_1" data-name="Rectangle 1" width="15" height="15" rx="3.5" transform="translate(0.5 0.5)" fill="none" stroke="#000" stroke-width="1"/>
</svg>

                                          </div>
                                          <div className="col-6 ">

                                            
                                              <span className=" myheav text-large mytext-warning hdhjsgdhgtext23424">
                                                  افزودن کارت جدید

                                              </span>

                                          </div>
                                      </div>

                                          </a>



                      </div>

                     




                  </form>
                  <form className={'col-4'}>
                      <div className={'border-dark'}>
                          <p></p>
                          <p>


                          </p>


                      </div>

                  </form>

              </div>


             <div className={'text-left  '}>

                 
                 <button type="button" className={'btn  btn-success btsubmit2020 '} data-inline={true} onClick={handelpayment}>ثبت برداشت</button>

             </div>

             <div className="card-tazakor">

             <div>
                <div className="tewxtushe63">توجه !</div>
                              <span className={'boskjfsgfd'}>                                        در موارد زیر درخواست وجه پرداخت نخواهد شد:</span>
                              <br/>
                              <span className="text-dark">نام صاحب حساب معرفی شده به نام شخص دیگری باشد.</span>
                              <br/>
                              <span className="text-dark">حساب مشترک باشد.</span>
                              <br/>
                              <span className="text-dark">حساب مسدود یا راکت باشد.</span>
                          </div>

             </div>

          </div>




      </Modal>


              :

              <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={customStylesDesktop}
        contentLabel="Example Modal"
        backdrop= "static"

      >


          <div className={'container'} id={'mbody'}>
              <div className={'title'}>
                  <span className="close" onClick={closeModal}>&times;</span>
                


              </div>

              <div className={'row'}>
                  <form className={'col-md-7 card820820 h-100'}>
                    <div className="titledesl820">برداشت تومانی</div>
                      <div className={'text-large'}>
                          حداکثر مبلغ قابل برداشت:

                          {new Intl.NumberFormat("fa").format(balance)}

                          تومان

                      </div>

                      <div className="all-balance-b">

<button type="button"
                                          className={'btn btn-sor btnes244 '} onClick={handleChooseBalanceClick}>
                                          کل موجودی
                                      </button>


</div>




                      <input id={'amount'} type={'input'} className={'form-control bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} onKeyUp={separateNum} placeholder={'مبلغ'}  />





                      <br/>


                      <div className="text-large jfhshjhfgs1323">
                            کارت مدنظر خود را انتخاب کنید
                        </div>



                  
                      <div className="panel-body list-group hfudgfu53535">
                                {carts ? carts.map((cart)=>(
                                    <div className="form-check border-dark ">

                                    <input className="form-check-input" type="radio" name="choice"
                                       id="flexRadioDefault1" value={cart.cart_number}/>
                                    <label className="form-check-label font-weight-bolder" >
                                        <span className="fofjsfdjf12">شماره کارت :

                                        <span className="fofjsfdjf12">
                                        {cart.cart_number}

                                        </span>
                                        </span>
                                        &nbsp;
                                        <br/>
                                        <span className="fofjsfdjf12">شماره شبا :
                                        <span className="fofjsfdjf12">
                                        {cart.sheba_number}


                                        </span>

                                        </span>

                                    </label>
                                    </div>
                                    )): <h5></h5>}


                        </div>



                    
                        {checkGoogle?

                            <div className={'w-100  text-white pb-2'}>
                                <label className={'text-large'}>کد تایید دو مرحله ای</label>


                                <div className={'text-center'}>


                                    <input
                                        className={'myinput_form text-center w-100 text-large bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6  '} id={'google_code'} value={google} onChange={e=>setGoogle(e.target.value)}
                                        />
                                </div>


                            </div>

                            :

                            <></>
                            }






                      <div className={''}>
                      <a href={'/ehzcart'} id={'abtn'} >
                                      <div class="row">
                                          <div className="col-1">
                                          <svg id="Group_27532" data-name="Group 27532" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
  <path id="Path_1" data-name="Path 1" d="M8.3,4.889a.292.292,0,0,0-.583,0V7.709H4.893a.292.292,0,1,0,0,.583H7.713v2.819a.292.292,0,1,0,.583,0V8.292h2.819a.292.292,0,0,0,0-.583H8.3Z" stroke="#000" stroke-width="1"/>
  <rect id="Rectangle_1" data-name="Rectangle 1" width="15" height="15" rx="3.5" transform="translate(0.5 0.5)" fill="none" stroke="#000" stroke-width="1"/>
</svg>

                                             
                                          </div>
                                          <div className="col-6 pl-1 pt-1">
                                              <span className=" myheav text-large mytext-warning">
                                                  افزودن کارت جدید

                                              </span>

                                          </div>
                                      </div>

                                          </a>


                      </div>


                      <div className={'text-center btnvariz '}>
                 <br/>
                 <br/>

                 <button type="button" className={'btn  btn-success btsubmit2020 majhsyug353'} data-inline={true} onClick={handelpayment}>ثبت برداشت</button>

             </div>



                  </form>
                  <form className={'col-5'}>
                     
             <div className="card-tazakor">

<div>
   <div className="tewxtushe63">توجه !</div>
                 <span className={'boskjfsgfd'}>                                        در موارد زیر درخواست وجه پرداخت نخواهد شد:</span>
                 <br/>
                 <span className="text-dark">نام صاحب حساب معرفی شده به نام شخص دیگری باشد.</span>
                 <br/>
                 <span className="text-dark">حساب مشترک باشد.</span>
                 <br/>
                 <span className="text-dark">حساب مسدود یا راکت باشد.</span>
             </div>

</div>

                  </form>

              </div>


          

          </div>




      </Modal>

          }
      </>

  )
}